import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import "../css/styles.css";
import { fetchToken } from "./Auth";

// --- HELPER DE DATA (Sem alteração) ---
const addDays = (dateString, days) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString + "T00:00:00");
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
  } catch (e) {
    return "";
  }
};

const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  try {
    return new Date(dateString).toISOString().split("T")[0];
  } catch (e) {
    return "";
  }
};

const formatBRL = (value) => {
  if (!value) return "";

  // 1. Converte para string (caso venha do DB como número) e remove tudo que não for dígito
  let digits = String(value).replace(/\D/g, "");

  // 2. Limita ao máximo do DECIMAL(10, 2)
  if (digits.length > 10) {
    digits = digits.slice(0, 10);
  }

  // 3. Adiciona zeros à esquerda se necessário
  digits = digits.padStart(3, "0");

  // 4. Divide em centavos e inteiros
  const cents = digits.slice(-2);
  const integer = digits.slice(0, -2);

  // 5. Formata a parte inteira
  const integerFormatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // 6. Junta tudo
  return `R$ ${integerFormatted},${cents}`;
};

function EditProjetoCompleto() {
  const { id } = useParams();
  const navigate = useNavigate();

  // --- States (sem alteração) ---
  const [id_secretaria, setSecretaria] = useState("");
  const [nomeprojeto, setNomeprojeto] = useState("");
  const [descricao, setDescricao] = useState("");
  const [ano_projeto, setAno_projeto] = useState("");
  const [processo_egov, setProcesso_egov] = useState("");
  const [numero_demanda, setNumero_demanda] = useState("");
  const [numero_convenio, setNumero_convenio] = useState("");
  const [valor_repasse, setValor_repasse] = useState("");
  const [valor_contrapartida, setValor_contrapartida] = useState("");
  const [parlamentar, setParlamentar] = useState("");
  const [contador, setContador] = useState("");
  const [gestor, setGestor] = useState("");
  const [fiscal, setFiscal] = useState("");
  const [data_assinatura_termo, setData_assinatura_termo] = useState("");
  const [vigencia_termo, setVigencia_termo] = useState("");
  const [data_inicio_etapa1, setData_inicio_etapa1] = useState("");
  const [data_termino_etapa1, setData_termino_etapa1] = useState("");
  const [prazo_etapa1, setPrazo_etapa1] = useState("90");
  const [situacao_etapa1, setSituacao_etapa1] = useState("");
  const [status_etapa1, setStatus_etapa1] = useState("");
  const [data_inicio_etapa2, setData_inicio_etapa2] = useState("");
  const [data_termino_etapa2, setData_termino_etapa2] = useState("");
  const [prazo_etapa2, setPrazo_etapa2] = useState("120");
  const [situacao_etapa2, setSituacao_etapa2] = useState("");
  const [status_etapa2, setStatus_etapa2] = useState("");
  const [data_inicio_etapa3, setData_inicio_etapa3] = useState("");
  const [data_termino_etapa3, setData_termino_etapa3] = useState("");
  const [prazo_etapa3, setPrazo_etapa3] = useState("120");
  const [situacao_etapa3, setSituacao_etapa3] = useState("");
  const [status_etapa3, setStatus_etapa3] = useState("");
  const [assinatura_contrato, setAssinatura_contrato] = useState("");
  const [vigencia_contrato, setVigencia_contrato] = useState("");
  const [data_inicio_etapa4, setData_inicio_etapa4] = useState("");
  const [data_termino_etapa4, setData_termino_etapa4] = useState("");
  const [prazo_etapa4, setPrazo_etapa4] = useState("30");
  const [situacao_etapa4, setSituacao_etapa4] = useState("");
  const [status_etapa4, setStatus_etapa4] = useState("");
  const [data_ois, setData_ois] = useState("");
  const [data_inicio_etapa5, setData_inicio_etapa5] = useState("");
  const [data_termino_etapa5, setData_termino_etapa5] = useState("");
  const [prazo_etapa5, setPrazo_etapa5] = useState("180");
  const [situacao_etapa5, setSituacao_etapa5] = useState("");
  const [status_etapa5, setStatus_etapa5] = useState("");
  const [data_inicio_etapa6, setData_inicio_etapa6] = useState("");
  const [data_termino_etapa6, setData_termino_etapa6] = useState("");
  const [prazo_etapa6, setPrazo_etapa6] = useState("60");
  const [situacao_etapa6, setSituacao_etapa6] = useState("");
  const [status_etapa6, setStatus_etapa6] = useState("");
  const [registerStatus, setRegisterStatus] = useState("");

  // --- EFEITO PARA BUSCAR DADOS DO PROJETO (ATUALIZADO) ---
  useEffect(() => {
    const token = fetchToken();
    if (!token) {
      alert("Sessão expirada. Faça login novamente.");
      navigate("/login");
      return;
    }

    axios
      .get(`/api/projetocompleto/${id}`)
      .then((res) => {
        if (res.data.Status === "Success" && res.data.Result.length > 0) {
          const data = res.data.Result[0];

          // --- Popula TODOS os states ---
          setSecretaria(data.id_secretaria || "");
          setNomeprojeto(data.nomeprojeto || "");
          setDescricao(data.descricao || "");
          setAno_projeto(data.ano_projeto || "");
          setProcesso_egov(data.processo_egov || "");
          setNumero_demanda(data.numero_demanda || "");
          setNumero_convenio(data.numero_convenio || "");

          // --- MUDANÇA: Formata os valores do DB ---
          setValor_repasse(formatBRL(data.valor_repasse));
          setValor_contrapartida(formatBRL(data.valor_contrapartida));

          setParlamentar(data.parlamentar || "");
          setContador(data.contador || "");
          setGestor(data.gestor || "");
          setFiscal(data.fiscal || "");
          setData_assinatura_termo(
            formatDateForInput(data.data_assinatura_termo)
          );
          setVigencia_termo(formatDateForInput(data.vigencia_termo));

          // Etapas... (sem alteração)
          setData_inicio_etapa1(formatDateForInput(data.data_inicio_etapa1));
          setData_termino_etapa1(formatDateForInput(data.data_termino_etapa1));
          setPrazo_etapa1(data.prazo_etapa1 || "90");
          setSituacao_etapa1(data.situacao_etapa1 || "");
          setStatus_etapa1(data.status_etapa1 || "");

          setData_inicio_etapa2(formatDateForInput(data.data_inicio_etapa2));
          setData_termino_etapa2(formatDateForInput(data.data_termino_etapa2));
          setPrazo_etapa2(data.prazo_etapa2 || "120");
          setSituacao_etapa2(data.situacao_etapa2 || "");
          setStatus_etapa2(data.status_etapa2 || "");

          setData_inicio_etapa3(formatDateForInput(data.data_inicio_etapa3));
          setData_termino_etapa3(formatDateForInput(data.data_termino_etapa3));
          setPrazo_etapa3(data.prazo_etapa3 || "120");
          setSituacao_etapa3(data.situacao_etapa3 || "");
          setStatus_etapa3(data.status_etapa3 || "");
          setAssinatura_contrato(formatDateForInput(data.assinatura_contrato));
          setVigencia_contrato(formatDateForInput(data.vigencia_contrato));

          setData_inicio_etapa4(formatDateForInput(data.data_inicio_etapa4));
          setData_termino_etapa4(formatDateForInput(data.data_termino_etapa4));
          setPrazo_etapa4(data.prazo_etapa4 || "30");
          setSituacao_etapa4(data.situacao_etapa4 || "");
          setStatus_etapa4(data.status_etapa4 || "");
          setData_ois(formatDateForInput(data.data_ois));

          setData_inicio_etapa5(formatDateForInput(data.data_inicio_etapa5));
          setData_termino_etapa5(formatDateForInput(data.data_termino_etapa5));
          setPrazo_etapa5(data.prazo_etapa5 || "180");
          setSituacao_etapa5(data.situacao_etapa5 || "");
          setStatus_etapa5(data.status_etapa5 || "");

          setData_inicio_etapa6(formatDateForInput(data.data_inicio_etapa6));
          setData_termino_etapa6(formatDateForInput(data.data_termino_etapa6));
          setPrazo_etapa6(data.prazo_etapa6 || "60");
          setSituacao_etapa6(data.situacao_etapa6 || "");
          setStatus_etapa6(data.status_etapa6 || "");
        } else {
          alert("Projeto não encontrado.");
          navigate("/projetocompleto");
        }
      })
      .catch((err) => {
        console.error("Erro ao buscar projeto:", err);
        alert("Erro ao carregar dados do projeto.");
        navigate("/projetocompleto");
      });
  }, [id, navigate]);

  useEffect(() => {
    if (data_inicio_etapa1) {
      setData_termino_etapa1(addDays(data_inicio_etapa1, 90));
      setPrazo_etapa1("90");
    }
  }, [data_inicio_etapa1]);

  useEffect(() => {
    if (data_inicio_etapa2) {
      setData_termino_etapa2(addDays(data_inicio_etapa2, 120));
      setPrazo_etapa2("120");
    }
  }, [data_inicio_etapa2]);

  useEffect(() => {
    if (data_inicio_etapa3) {
      setData_termino_etapa3(addDays(data_inicio_etapa3, 120));
      setPrazo_etapa3("120");
    }
  }, [data_inicio_etapa3]);

  useEffect(() => {
    if (data_inicio_etapa4) {
      setData_termino_etapa4(addDays(data_inicio_etapa4, 30));
      setPrazo_etapa4("30");
    }
  }, [data_inicio_etapa4]);

  useEffect(() => {
    if (data_inicio_etapa5) {
      setData_termino_etapa5(addDays(data_inicio_etapa5, 180));
      setPrazo_etapa5("180");
    }
  }, [data_inicio_etapa5]);

  useEffect(() => {
    if (data_inicio_etapa6) {
      setData_termino_etapa6(addDays(data_inicio_etapa6, 60));
      setPrazo_etapa6("60");
    }
  }, [data_inicio_etapa6]);

  const handleCurrencyChange = (e, setter) => {
    const formattedValue = formatBRL(e.target.value);
    setter(formattedValue);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const token = fetchToken();

    if (!token) {
      setRegisterStatus("Erro: Token não encontrado. Faça login novamente.");
      return;
    }

    const cleanValue = (value) => {
      if (typeof value !== "string") return value;
      return value
        .replace("R$", "")
        .replace(/\./g, "")
        .replace(",", ".")
        .trim();
    };

    const valorRepasseLimpo = cleanValue(valor_repasse);
    const valorContrapartidaLimpo = cleanValue(valor_contrapartida);

    axios
      .put(
        `/api/projetocompleto/${id}`,
        {
          id_secretaria,
          nomeprojeto,
          descricao,
          ano_projeto,
          processo_egov,
          numero_demanda,
          numero_convenio,
          valor_repasse: valorRepasseLimpo, // Envia o valor limpo
          valor_contrapartida: valorContrapartidaLimpo, // Envia o valor limpo
          parlamentar,
          data_inicio_etapa1,
          data_termino_etapa1,
          prazo_etapa1,
          situacao_etapa1,
          status_etapa1,
          contador,
          gestor,
          fiscal,
          data_assinatura_termo,
          vigencia_termo,
          data_inicio_etapa2,
          data_termino_etapa2,
          prazo_etapa2,
          situacao_etapa2,
          status_etapa2,
          data_inicio_etapa3,
          data_termino_etapa3,
          prazo_etapa3,
          situacao_etapa3,
          status_etapa3,
          assinatura_contrato,
          vigencia_contrato,
          data_inicio_etapa4,
          data_termino_etapa4,
          prazo_etapa4,
          situacao_etapa4,
          status_etapa4,
          data_ois,
          data_inicio_etapa5,
          data_termino_etapa5,
          situacao_etapa5,
          prazo_etapa5,
          status_etapa5,
          data_inicio_etapa6,
          data_termino_etapa6,
          prazo_etapa6,
          situacao_etapa6,
          status_etapa6,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.Status === "Success") {
          navigate("/projetocompleto");
          alert("Projeto atualizado com sucesso!");
        } else {
          setRegisterStatus(response.data.message || "Erro ao atualizar.");
        }
      })
      .catch((err) => {
        console.log(err);
        // Exibe o erro "Out of range" se ele ocorrer
        if (err.response?.data?.details?.includes("Out of range")) {
          setRegisterStatus(
            "Erro: Valor muito alto! O máximo permitido é R$ 99.999.999,99."
          );
        } else {
          setRegisterStatus(
            err.response?.data?.error ||
              err.response?.data?.message ||
              "Erro ao atualizar projeto."
          );
        }
      });
  };

  return (
    <form className="container" onSubmit={handleUpdate}>
      <h2>EDITAR PROJETO (ID: {id})</h2>
      <div className="fs-1 px-5 py-3">
        <Link to="/numero" className="btn btn-info px-5 g-5 me-2">
          Dashboard
        </Link>
        <Link
          to="/numero/projetocompleto"
          className="btn btn-warning px-5 g-5 me-2"
        >
          Retorna projeto
        </Link>
      </div>
      <div className="main-container">
        <div className="containerdashboard">
          <h1>{registerStatus}</h1>

          {/* --- Etapa 1 --- */}
          <h3>Etapa 1: Definição do objeto / Estruturação do projeto</h3>
          {/* ... (Campos: Secretaria, Nome, Descrição, Ano, E-gov, Demanda, Convênio) ... */}
          {/* (Omitidos por brevidade) */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Secretaria</label>
              <select
                type="text"
                className="form-control"
                required
                value={id_secretaria}
                onChange={(e) => {
                  setSecretaria(e.target.value);
                }}
              >
                <option value="">Selecione a secretaria</option>
                <option value="1">
                  02.20 -Secretaria de Políticas para as Mulheres
                </option>
                <option value="2">Assessoria Especial de Defesa Civil</option>
                <option value="3">
                  02.11 - Secretaria Municipal de Turismo e Lazer
                </option>
                <option value="4">
                  02.15 - Secretaria Municipal de Governo e Gestão Estratégica
                </option>
                <option value="5">
                  02.13 - Secretaria Municipal da Agricultura
                </option>
                <option value="6">
                  02.17 - Secretaria Municipal de Meio Ambiente
                </option>
                <option value="7">
                  02.09 - Secretaria Municipal da Educação
                </option>
                <option value="8">
                  02.05 - Secretaria Municipal da Administração
                </option>
                <option value="9">SAEG</option>
                <option value="10">
                  02.10 - Secretaria Municpal de Esportes
                </option>
                <option value="11">
                  02.18 - Secretaria Municipal da Indústria, Comércio e Gestão
                  de Convênios
                </option>
                <option value="12">
                  02.07 - Secretaria Municipal de Obras e Serviços Municipais
                </option>
                <option value="13">Assessoria de Coordenação Política</option>
                <option value="14">02.02 - Chefia de Gabinete</option>
                <option value="15">
                  02.04 - Secretaria Municipal da Fazenda
                </option>
                <option value="16">
                  02.19 - Secretaria Municipal de Relações Institucionais e
                  Controle Interno
                </option>
                <option value="17">
                  02.11 - Secretaria Municipal de Saúde
                </option>
                <option value="18">
                  02.06 - Secretaria Municipal de Justiça e Cidadania
                </option>
                <option value="19">
                  Assessor Especial de Relações Publicitárias e Imprensa
                </option>
                <option value="20">
                  02.08 - Secretaria Municipal de Segurança e Mobilidade Urbana
                </option>
                <option value="21">
                  Assessoria de Geração de Empregos e Renda
                </option>
                <option value="22">
                  02.14 Secretaria Municipal de Assistência Social
                </option>
                <option value="23">CODESG</option>
                <option value="24">Assessoria de Promoção Social</option>
                <option value="25">Assessoria de Projetos Legislativos</option>
                <option value="26">
                  02.16 - Secretaria Municipal da Cultura
                </option>
                <option value="27">
                  02.03 - Secretaria Municipal de Planejamento, Coordenação e
                  Habitação
                </option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Nome do projeto</label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite o nome do projeto"
                autoComplete="off"
                value={nomeprojeto}
                onChange={(e) => {
                  setNomeprojeto(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Descrição do projeto</label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite a descrição do projeto"
                autoComplete="off"
                value={descricao}
                onChange={(e) => {
                  setDescricao(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Ano do projeto</label>
              <input
                type="number"
                className="form-control"
                placeholder="Digite o ano do projeto"
                autoComplete="off"
                value={ano_projeto}
                onChange={(e) => {
                  setAno_projeto(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Processo E-gov</label>
              <input
                type="text"
                className="form-control"
                placeholder="Nº Processo E-gov"
                autoComplete="off"
                value={processo_egov}
                onChange={(e) => {
                  setProcesso_egov(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Número da Demanda</label>
              <input
                type="number"
                className="form-control"
                placeholder="Nº da Demanda"
                autoComplete="off"
                value={numero_demanda}
                onChange={(e) => {
                  setNumero_demanda(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Número do Convênio</label>
              <input
                type="text"
                className="form-control"
                placeholder="Nº do Convênio"
                autoComplete="off"
                value={numero_convenio}
                onChange={(e) => {
                  setNumero_convenio(e.target.value);
                }}
              />
            </div>
          </div>

          {/* --- MUDANÇA: Campos de Valor Atualizados --- */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Valor de Repasse</label>
              <input
                type="text" // <-- MUDANÇA
                className="form-control"
                placeholder="R$ 0,00"
                autoComplete="off"
                value={valor_repasse} // <-- MUDANÇA
                onChange={(e) => handleCurrencyChange(e, setValor_repasse)} // <-- MUDANÇA
              />
            </div>
            <div className="col">
              <label className="form-label">Valor Contrapartida</label>
              <input
                type="text" // <-- MUDANÇA
                className="form-control"
                placeholder="R$ 0,00"
                autoComplete="off"
                value={valor_contrapartida} // <-- MUDANÇA
                onChange={(e) =>
                  handleCurrencyChange(e, setValor_contrapartida)
                } // <-- MUDANÇA
              />
            </div>
            <div className="col">
              <label className="form-label">Parlamentar</label>
              <input
                type="text"
                className="form-control"
                placeholder="Nome do parlamentar"
                autoComplete="off"
                value={parlamentar}
                onChange={(e) => {
                  setParlamentar(e.target.value);
                }}
              />
            </div>
          </div>
          {/* ... (Restante do formulário Etapa 1) ... */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 1</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_inicio_etapa1}
                onChange={(e) => {
                  setData_inicio_etapa1(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Data de Término Etapa 1</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_termino_etapa1}
                readOnly
                onChange={(e) => {
                  setData_termino_etapa1(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação Etapa 1</label>
              <select
                type="text"
                className="form-control"
                autoComplete="off"
                value={situacao_etapa1}
                onChange={(e) => {
                  setSituacao_etapa1(e.target.value);
                }}
              >
                <option value="">Escolher a situação</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status Etapa 1</label>
              <input
                type="text"
                className="form-control"
                placeholder="Status (Ex: Aguardando)"
                autoComplete="off"
                value={status_etapa1}
                onChange={(e) => {
                  setStatus_etapa1(e.target.value);
                }}
              />
            </div>
          </div>

          {/* --- Etapa 2 (TdR e Orçamento) --- */}
          <hr />
          <h3>Etapa 2: TdR e Orçamento</h3>
          {/* ... (Campos: Contador, Gestor, Fiscal, Datas...) ... */}
          {/* (Omitidos por brevidade) */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Nome do Contador</label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite o nome do contador"
                autoComplete="off"
                value={contador}
                onChange={(e) => {
                  setContador(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Nome do Gestor</label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite o nome do gestor"
                autoComplete="off"
                value={gestor}
                onChange={(e) => {
                  setGestor(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Nome do Fiscal</label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite o nome do fiscal"
                autoComplete="off"
                value={fiscal}
                onChange={(e) => {
                  setFiscal(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data Assinatura Termo</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_assinatura_termo}
                onChange={(e) => {
                  setData_assinatura_termo(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Vigência do Termo</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={vigencia_termo}
                onChange={(e) => {
                  setVigencia_termo(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 2</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_inicio_etapa2}
                onChange={(e) => {
                  setData_inicio_etapa2(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Data de Término Etapa 2</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_termino_etapa2}
                readOnly
                onChange={(e) => {
                  setData_termino_etapa2(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação Etapa 2</label>
              <select
                type="text"
                className="form-control"
                autoComplete="off"
                value={situacao_etapa2}
                onChange={(e) => {
                  setSituacao_etapa2(e.target.value);
                }}
              >
                <option value="">Escolher a situação</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status Etapa 2</label>
              <input
                type="text"
                className="form-control"
                placeholder="Status"
                autoComplete="off"
                value={status_etapa2}
                onChange={(e) => {
                  setStatus_etapa2(e.target.value);
                }}
              />
            </div>
          </div>

          {/* --- Etapa 3 (Licitação) --- */}
          <hr />
          <h3>Etapa 3: Licitação</h3>
          {/* ... (Campos: Datas, Situação, Status) ... */}
          {/* (Omitidos por brevidade) */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 3</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_inicio_etapa3}
                onChange={(e) => {
                  setData_inicio_etapa3(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Data de Término Etapa 3</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_termino_etapa3}
                readOnly
                onChange={(e) => {
                  setData_termino_etapa3(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação Etapa 3</label>
              <select
                type="text"
                className="form-control"
                autoComplete="off"
                value={situacao_etapa3}
                onChange={(e) => {
                  setSituacao_etapa3(e.target.value);
                }}
              >
                <option value="">Escolher a situação</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status Etapa 3</label>
              <input
                type="text"
                className="form-control"
                placeholder="Status"
                autoComplete="off"
                value={status_etapa3}
                onChange={(e) => {
                  setStatus_etapa3(e.target.value);
                }}
              />
            </div>
          </div>

          {/* --- Etapa 4 (Contrato) --- */}
          <hr />
          <h3>Etapa 4: Contrato</h3>
          {/* ... (Campos: Assinatura, Vigência, Datas, Situação, Status) ... */}
          {/* (Omitidos por brevidade) */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Assinatura do Contrato</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={assinatura_contrato}
                onChange={(e) => {
                  setAssinatura_contrato(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Vigência do Contrato</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={vigencia_contrato}
                onChange={(e) => {
                  setVigencia_contrato(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 4</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_inicio_etapa4}
                onChange={(e) => {
                  setData_inicio_etapa4(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Data de Término Etapa 4</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_termino_etapa4}
                readOnly
                onChange={(e) => {
                  setData_termino_etapa4(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação Etapa 4</label>
              <select
                type="text"
                className="form-control"
                autoComplete="off"
                value={situacao_etapa4}
                onChange={(e) => {
                  setSituacao_etapa4(e.target.value);
                }}
              >
                <option value="">Escolher a situação</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status Etapa 4</label>
              <input
                type="text"
                className="form-control"
                placeholder="Status"
                autoComplete="off"
                value={status_etapa4}
                onChange={(e) => {
                  setStatus_etapa4(e.target.value);
                }}
              />
            </div>
          </div>

          {/* --- Etapa 5 (execução) --- */}
          <hr />
          <h3>Etapa 5: Execução</h3>
          {/* ... (Campos: OIS, Datas, Situação, Status) ... */}
          {/* (Omitidos por brevidade) */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data OIS</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_ois}
                onChange={(e) => {
                  setData_ois(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Data de Início Etapa 5</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_inicio_etapa5}
                onChange={(e) => {
                  setData_inicio_etapa5(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Data de Término Etapa 5</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_termino_etapa5}
                readOnly
                onChange={(e) => {
                  setData_termino_etapa5(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação Etapa 5</label>
              <select
                type="text"
                className="form-control"
                autoComplete="off"
                value={situacao_etapa5}
                onChange={(e) => {
                  setSituacao_etapa5(e.target.value);
                }}
              >
                <option value="">Escolher a situação</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status Etapa 5</label>
              <input
                type="text"
                className="form-control"
                placeholder="Status"
                autoComplete="off"
                value={status_etapa5}
                onChange={(e) => {
                  setStatus_etapa5(e.target.value);
                }}
              />
            </div>
          </div>

          {/* --- Etapa 6 (Encerramento) --- */}
          <hr />
          <h3>Etapa 6: Encerramento</h3>
          {/* ... (Campos: Datas, Situação, Status) ... */}
          {/* (Omitidos por brevidade) */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 6</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_inicio_etapa6}
                onChange={(e) => {
                  setData_inicio_etapa6(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <label className="form-label">Data de Término Etapa 6</label>
              <input
                type="date"
                className="form-control"
                autoComplete="off"
                value={data_termino_etapa6}
                readOnly
                onChange={(e) => {
                  setData_termino_etapa6(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação Etapa 6</label>
              <select
                type="text"
                className="form-control"
                autoComplete="off"
                value={situacao_etapa6}
                onChange={(e) => {
                  setSituacao_etapa6(e.target.value);
                }}
              >
                <option value="">Escolher a situação</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status Etapa 6</label>
              <input
                type="text"
                className="form-control"
                placeholder="Status"
                autoComplete="off"
                value={status_etapa6}
                onChange={(e) => {
                  setStatus_etapa6(e.target.value);
                }}
              />
            </div>
          </div>

          {/* --- BOTÕES --- */}
          <div className="input-dividido">
            <div className="col">
              <button type="submit" className="submit-button">
                Atualizar Projeto
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default EditProjetoCompleto;
